export default __webpack_public_path__ + "static/media/0026.48326878.png";